<template>
	<div class="user-menu">
		<xyz-transition mode="out-in" xyz="fade small">
			<button
				type="button"
				class="sign-in-up__button button--outline button--small"
				:class="{ 'button--translucent translucent--white': signInBlur, 'button--white': themeLight }"
				v-if="!user"
				@click="openSignInUpModal"
			>
				Sign In / Sign Up
			</button>

			<dropdown class="profile__dropdown" :position="'bottom-right'" v-if="user">
				<template v-slot:toggle>
					<div class="header-button" :class="{ 'header-button--light': themeLight }">
						<span class="header-button__label">{{ userName }}</span>
						<div class="header-button__icon">
							<icon-person></icon-person>
						</div>
					</div>
				</template>
				<template v-slot:content>
					<ul class="dropdown-content list--no-style">
						<li v-if="user.isRegistered">
							<button type="button" @click="openUserInfoModal">Edit My Profile</button>
						</li>
						<li v-if="eventUser">
							<button type="button" @click="openEventUserInfoModal">Edit My Event Info</button>
						</li>
						<li>
							<button type="button" @click="openDonateModal">Donate</button>
						</li>
						<li v-if="eventUser && !user.isRegistered">
							<button type="button" @click="openSignInUpModal">Make Account</button>
						</li>
						<li>
							<button type="button" @click="openSignOutModal">
								{{ user.isRegistered ? 'Sign Out' : `Not ${userName}?` }}
							</button>
						</li>
						<li v-if="user.isRegistered">
							<button type="button" class="button--red" @click="openDeleteAccountModal">Delete Account</button>
						</li>
					</ul>
				</template>
			</dropdown>
		</xyz-transition>
	</div>
</template>

<script>
import Dropdown from '@/components/reusable/Dropdown'
import IconPerson from '@/components/icons/IconPerson.svg'
import { mapState } from 'vuex'

export default {
	name: 'UserMenu',
	props: {
		signInBlur: {
			type: Boolean,
		},
		themeLight: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		Dropdown,
		IconPerson,
	},
	computed: {
		...mapState({
			appearance: (state) => state.appearance,
		}),
		...mapState({
			user: (state) => state.user,
		}),
		eventUser() {
			if (this.$store.state.event && this.$store.state.event.user) {
				return this.$store.state.event.user
			} else {
				return null
			}
		},
		userName() {
			return this.eventUser ? this.eventUser.name : this.user.name
		},
	},
	methods: {
		openSignInUpModal() {
			this.$store.dispatch('openModal', { name: 'signInUpModal' })
		},
		openUserInfoModal() {
			this.$store.dispatch('openModal', { name: 'userInfoModal' })
		},
		openEventUserInfoModal() {
			this.$store.dispatch('openModal', { name: 'eventUserInfoModal' })
		},
		openDeleteAccountModal() {
			this.$store.dispatch('openModal', { name: 'deleteAccountModal' })
		},
		openSignOutModal() {
			this.$store.dispatch('openModal', { name: 'signOutModal' })
		},
		openDonateModal() {
			this.$store.dispatch('openModal', { name: 'donateModal' })
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .header-button__label {
	@include text-ellipsis;
	max-width: 12rem;

	@include media('<desktop') {
		display: none;
	}
}
</style>
